import React from "react";

import ContentCore from "../../../core/workingContent";

import "../_index.css";

const TaskDelay = () => {
  return (
    <>
      <ContentCore />
    </>
  )
}

export default TaskDelay;
